import React, {ReactNode} from 'react';

interface DisabledWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: ReactNode
}

const DisabledWrapper: React.FC<DisabledWrapperProps> = ({className, style, children, ...props}) => {
    return (
        <div {...props} style={{
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            userSelect: 'none',
            overflow: 'hidden',
            ...style
        }}>
            {children}
        </div>
    );
};

export default DisabledWrapper;
